import { TemplateStatus } from '@ViewModels';
import { css } from 'aphrodite';
import { observer } from 'mobx-react';
import * as React from 'react';
import { IndustryHtmlNewsletterViewModel } from '../../../../viewmodels/AdminViewModels';
import { ISelectOption } from '../../../../web/components/DeprecatedSelect';
import {
	HtmlNewsletterEditorAutoSaveCheckbox,
	HtmlNewsletterEditorHeader,
	HtmlNewsletterEditorSaveAsNewButton,
	HtmlNewsletterEditorSaveButton,
} from '../../../../web/components/HtmlNewsletterEditor/presentation';
import { LoadingSpinner } from '../../../../web/components/LoadingSpinner';
import { baseStyleSheet } from '../../../../web/styles/styles';
import { IndustriesDropdown, TemplateIndustryOption } from '../../../components/IndustriesDropdown';
import { styleSheet } from './styles';

interface IEditIndustryHtmlNewsletterTemplateHeaderProps {
	hideSaveAsNewTemplate?: boolean;
	industryNewsletter?: IndustryHtmlNewsletterViewModel;
	save?(publish?: boolean, toast?: boolean): void;
	selectedIndustryOptions?: ISelectOption<TemplateIndustryOption>[];
	setSelectedIndustryOptions?(optons: ISelectOption<TemplateIndustryOption>[]): void;
}

export const EditIndustryHtmlNewsletterTemplateHeader: React.FC<IEditIndustryHtmlNewsletterTemplateHeaderProps> =
	observer(
		({ hideSaveAsNewTemplate, industryNewsletter, save, selectedIndustryOptions, setSelectedIndustryOptions }) => {
			return (
				<HtmlNewsletterEditorHeader>
					<div className={css(baseStyleSheet.horizontalStack)}>
						<span>Industries: &nbsp;</span>
						{selectedIndustryOptions ? (
							<IndustriesDropdown
								onSelectedIndustryOptionsChanged={setSelectedIndustryOptions}
								selectedIndustryOptions={selectedIndustryOptions}
							/>
						) : (
							<LoadingSpinner type='small' />
						)}
					</div>
					{!!industryNewsletter.statuses?.every(x => x.status === TemplateStatus.Draft) && (
						<>
							<HtmlNewsletterEditorAutoSaveCheckbox />
							<HtmlNewsletterEditorSaveButton onClick={() => save(false, true)} />
						</>
					)}
					{!hideSaveAsNewTemplate && <HtmlNewsletterEditorSaveAsNewButton />}
					<button className={css(styleSheet.publishButton)} onClick={() => save(true, true)}>
						<span>Save & Publish</span>
					</button>
				</HtmlNewsletterEditorHeader>
			);
		}
	);
